export enum RoleEnum {
  Anonymous = 0,
  SuperUser = 1,
  SystemAdministrator = 2,
  WebsiteAdministrator = 3,
  WebsiteContentManager = 4,

  JobseekerPending = 11,
  JobseekerRegistered = 12,
  JobseekerSuspended = 13,
  JobseekerActive = 14,

  CustomerPending = 21,
  CustomerRegistered = 22,
  CustomerSuspended = 23,
  CustomerActive = 24,

  CustomerAssistance = 31,
  CustomerAssistanceLimited = 32,
}
